import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import { PurpleButton } from 'Components/Button/PurpleButton';

import {
  TimesheetsList,
  TimesheetFilters,
  CreateTimeCardModal,
  EditTimeCardModal,
  DeleteTimeCardModal,
  TimeCardNotesModal,
  DownloadTimesheetsModal,
  ManageTimecardTypesModal,
  TimesheetReports,
} from 'Containers/TimeTracking';

import classes from './timesheets.module.css';

interface Props {
  getTimeCards: (e: any) => void;
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  onCreateTimeCardButtonClick: (e: any) => void;
  onDownloadButtonClick: (e: any) => void;
  onManageTypesButtonClick: (e: any) => void;
  activeTab: 'timesheets' | 'reports';
  onTabChange: (tab: 'timesheets' | 'reports') => void;
  sortBy: string;
  onSortChange: (sort: string) => void;
}

const Timesheets = ({ getTimeCards, pageSize, onPageSizeChange, onCreateTimeCardButtonClick, onDownloadButtonClick, onManageTypesButtonClick, activeTab, onTabChange, sortBy, onSortChange }: Props) => (
  <div className={classes.container}>
    <div className={`d-flex justify-content-start align-items-center ${classes.contentHeader}`}>
      <h2>Timesheets</h2>

      <PurpleButton className={classes.addTimecardButton} onClick={onCreateTimeCardButtonClick}>
        Create Time Card +
      </PurpleButton>
      <PurpleButton
        className={activeTab === 'timesheets' ? classes.tabButtonActive : classes.tabButton}
        onClick={() => onTabChange('timesheets')}
      >
        Timesheets
      </PurpleButton>
      <PurpleButton
        className={activeTab === 'reports' ? classes.tabButtonActive : classes.tabButton}
        onClick={() => onTabChange('reports')}
      >
        Reports
      </PurpleButton>
      <PurpleButton className={classes.downloadButton} onClick={onDownloadButtonClick}>
        Download
      </PurpleButton>
      <PurpleButton className={classes.manageTypesButton} onClick={onManageTypesButtonClick}>
        Manage Types
      </PurpleButton>
    </div>

    <TimesheetFilters />

    {activeTab === 'timesheets' && (
      <TimesheetsList getTimeCards={getTimeCards} pageSize={pageSize} onPageSizeChange={onPageSizeChange} sortBy={sortBy} onSortChange={onSortChange} />
    )}

    {activeTab === 'reports' && <TimesheetReports />}

    <CreateTimeCardModal />
    <TimeCardNotesModal />
    <EditTimeCardModal />
    <DeleteTimeCardModal />
    <DownloadTimesheetsModal />
    <ManageTimecardTypesModal />
  </div>
);

const TimesheetsMemo = memo(Timesheets, areEqual);

export { TimesheetsMemo as Timesheets };
